import { STATS, ABOUT_TILES } from "../mock";
import { Rocket, Hourglass, HeartHandshake, Globe2, ArrowUpRight } from "lucide-react";

const ICONS = { Rocket, Hourglass, HeartHandshake, Globe2 };

function StatCard({ s, className = "" }) {
  const Icon = ICONS[s.icon];
  const dark = s.color.includes("text-white");
  return (
    <div
      className={`relative ${s.color} ${className} rounded-[26px] p-6 md:p-7 mt-4 min-h-[150px] md:min-h-[170px] flex flex-col justify-between reveal group`}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={`absolute -top-4 h-8 w-[30%] rounded-full ${s.color.split(" ")[0]}`}
          style={{ left: `${2 + i * 33}%` }}
        />
      ))}
      <div className="flex items-center justify-between">
        <span
          className={`w-11 h-11 shrink-0 rounded-full flex items-center justify-center ${
            dark ? "bg-white text-black" : "bg-black text-white"
          } group-hover:rotate-12 transition-transform duration-500`}
        >
          <Icon size={20} />
        </span>
        <span
          className={`hidden sm:inline-flex items-center gap-1 h-7 px-2.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${
            dark ? "bg-white/15" : "bg-black/10"
          }`}
        >
          <ArrowUpRight size={12} /> {s.trend}
        </span>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-end gap-1 sm:gap-3 mt-5">
        <p className="display text-5xl md:text-[56px] leading-none">{s.value}</p>
        <p className="text-xs md:text-sm opacity-80 sm:pb-1.5 leading-tight">{s.label}</p>
      </div>
    </div>
  );
}

export default function AboutStats() {
  return (
    <div
      data-testid="about-stats"
      className="grid grid-cols-2 md:grid-cols-[1fr_1.15fr_1fr] gap-4 md:gap-5 mt-4"
    >
      <StatCard s={STATS[0]} className="md:col-start-1 md:row-start-1" />
      <StatCard s={STATS[1]} className="md:col-start-1 md:row-start-2" />
      <div className="col-span-2 md:col-span-1 md:col-start-2 md:row-start-1 md:row-span-2 rounded-[26px] overflow-hidden mt-4 min-h-[220px] reveal group">
        <img
          src={ABOUT_TILES.stat}
          alt="team at work"
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
      </div>
      <StatCard s={STATS[2]} className="md:col-start-3 md:row-start-1" />
      <StatCard s={STATS[3]} className="md:col-start-3 md:row-start-2" />
    </div>
  );
}
